module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"content":"Downloading update, please wait."},"es":{"content":"Descargando una actualización, espere."},"fr":{"content":"Téléchargement d\u0027une mise à jour, merci de patienter."},"it":{"content":"Download dell\u0027aggiornamento in corso, attendi."},"pt":{"content":"A transferir a atualização, por favor aguarde."},"pl":{"content":"Pobieranie aktualizacji, proszę czekać."}}')
  delete Component.options._Ctor
}
